import { NavLink, Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const navItemsData = [
  { to: '/home', translationKey: 'nav.home' },
  { to: '/about-us', translationKey: 'nav.about_us' },
  { to: '/products', translationKey: 'nav.products' },
  { to: '/news', translationKey: 'nav.news' },
  { to: '/kiem-tra-san-pham', translationKey: 'nav.check_product' },
  { to: '/contact', translationKey: 'nav.contact' },
];

const Navbar = () => {
  const { lang } = useParams<{ lang: string }>();
  const { t } = useTranslation();
  
  const currentLang = lang || 'vi';

  return (
    <header className="w-full fixed top-0 left-0 z-50 bg-white shadow">
      <div className="bg-[#658C4A] text-white text-center py-2 text-sm font-medium">
        {t('navbar.welcome')} <span className="font-bold">CleanToGreen</span>!
      </div>

      <nav className="border-b border-gray-200">
        <div className="flex flex-col items-center py-4 relative">
          <div className="flex items-center justify-center w-full px-4 relative">
            <Link to={`/${currentLang}/home`}>
              <img src="/images/CTG-logo/Logo2.png" alt="Logo" className="h-14 mb-2 cursor-pointer" />
            </Link>

            <div className="absolute right-4 top-1/2 -translate-y-1/2 transform">
              <LanguageSwitcher />
            </div>
          </div>

          <ul className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm md:text-base font-light text-center">
            {navItemsData.map((item) => (
              <NavItem key={item.to} to={`/${currentLang}${item.to}`}>
                {t(item.translationKey)}
              </NavItem>
            ))}
          </ul>
        </div>
      </nav>
    </header>
  );
};

interface NavItemProps {
  to: string;
  children: React.ReactNode;
}

const NavItem = ({ to, children }: NavItemProps) => (
  <li>
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive
          ? 'text-[#658C4A] font-semibold'
          : 'text-gray-800 hover:text-[#658C4A] transition-colors duration-200'
      }
    >
      {children}
    </NavLink>
  </li>
);

export default Navbar;